import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

/**
 * Generic confirmation dialog used across the app.
 *
 * `data.title` and `data.message` may be either a raw string or an i18n key
 * (e.g. `cashier.clearCart.title`). If a key matches an entry in the active
 * translation file it is resolved; otherwise the literal string is shown.
 *
 * Optional fields:
 *   data.icon        — material icon name shown in the header (default: 'help_outline')
 *   data.confirmText — translation key/text for the confirm button
 *   data.cancelText  — translation key/text for the cancel button
 *   data.danger      — when true, primary button is rendered in danger/red palette
 */
@Component({
  selector: 'app-notification-confirmation-component',
  templateUrl: './notification-confirmation.component.html',
  styleUrls: ['./notification-confirmation.component.scss']
})
export class NotificationConfirmationComponent implements OnInit {

  description: string;
  message: string;
  icon: string;
  confirmText: string;
  cancelText: string;
  danger: boolean;

  constructor(private dialogRef: MatDialogRef<NotificationConfirmationComponent>, private translate: TranslateService,
              @Inject(MAT_DIALOG_DATA) data) {
    this.description = this.resolve(data.title);
    this.message = this.resolve(data.message);
    this.icon = data.icon || 'help_outline';
    this.confirmText = this.resolve(data.confirmText) || this.resolve('button.confirm') || 'Confirm';
    this.cancelText = this.resolve(data.cancelText) || this.resolve('button.cancel') || 'Cancel';
    this.danger = !!data.danger;
  }

  ngOnInit() {
  }

  /**
   * Resolves `value` through the translate pipe when it looks like an i18n key
   * (contains a dot and no spaces). When the key is missing the translate
   * service returns the key itself; we fall back to the original string so we
   * never expose raw keys to end-users.
   */
  private resolve(value: string): string {
    if (!value) {
      return value;
    }
    const looksLikeKey = value.indexOf('.') > -1 && value.indexOf(' ') === -1;
    if (!looksLikeKey) {
      return value;
    }
    const translated = this.translate.instant(value);
    return translated && translated !== value ? translated : value;
  }

  close() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
